<template>
  <div class="accordion">
    <sc-placeholder name="jss-accordion-item" :rendering="rendering" />
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Accordion',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    rendering: {
      type: Object
    }
  }
};
</script>

<style lang="scss">
.accordion {
  margin-bottom: 5rem;

  &__item {
    border-bottom: 0.2rem solid $divider;

    &.open {
      background: $box-gray;

      div {
        &:first-child {
          &:before {
            transform: translate(3.8rem, -0.7rem) rotate(135deg);
          }
        }
      }
      .accordion__item--content {
        display: block;
      }
    }

    &--title {
      display: flex;
      align-items: center;
      width: 100%;
      position: relative;
      padding: 1.6rem 4.5rem 1.6rem 2rem;
      cursor: pointer;

      @include tablet-up {
        padding-left: 1.6rem;
      }

      &:hover {
        background: $box-gray;
      }

      &:before {
        font-weight: 700;
        font-size: 2rem;
        content: '∟';
        transform: translate(3.5rem, -1.67rem) rotate(-45deg);
        color: $blue;
        position: absolute;
        top: 50%;
        right: 5rem;
        pointer-events: none;
      }
    }

    &--icon {
      margin-right: 1.6rem;

      img {
        max-width: 6rem;
        height: auto;
      }
    }

    &--content {
      padding: 0 4rem 2.2rem 2rem;
      display: none;

      @include tablet-up {
        padding-left: 4rem;
      }
    }

    &.scEnabledChrome {
      .accordion__item--content {
        display: block;
      }
    }
  }

  h4 {
    @include font-styles('Arial', 1.8rem, 300, normal, 2.4rem, 0, $blue);
    margin: 0;

    @include tablet-up {
      @include font-styles('Arial', 2.8rem, 300, normal, 3.5rem, 0, $blue);
    }

    &::before {
      display: none;
    }
  }

  h5 {
    font-size: 2rem;
    font-weight: 500;
    padding: 0;
    margin: 0 0 1.5rem 0;
  }

  ul,
  &__unordered-list {
    @include font-styles('Arial', 2rem, 200, normal, 3rem, 0, $gray);
    margin: 0 0 1.6rem 1.6rem;
    padding: 0;
    list-style-type: disc;

    li {
      margin: 0 0 1.6rem 1.6rem;
      position: relative;

      @include font-styles('Arial', 1.6rem, 200, normal, 2rem, 0, $gray);

      @include tablet-up {
        @include font-styles('Arial', 2rem, 200, normal, 3rem, 0, $gray);
      }

      &::marker {
        color: $orange;
        font-size: 1.4rem;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.scEnabledChrome {
    > div {
      padding-bottom: 3rem;
    }
  }
}
</style>
